import "./index.scss";

type Props = {
  title?: string;
  value?: string;
};

const CustomInfoCard = ({ title, value }: Props) => {
  return (
    <div className="custom-card-info">
      <div>{title + " : " + value}</div>
    </div>
  );
};

export default CustomInfoCard;
